module.exports = __webpack_public_path__ + "img/icaon_tixian_02@2x.bbf18ec7.png";